export default __webpack_public_path__ + "static/media/rotted_curtains3.429e9bc9.png";